import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import hasFocusedOption from '../actions/hasFocusedOption'
import hasFilteredOptions from '../actions/hasFilteredOptions'

export default [
  hasFilteredOptions,
  {
    true: [
      hasFocusedOption,
      {
        true: [
          ({ state, props }) => {
            const focusedOption = props.focusedOption
            if (focusedOption + 1 < props.filteredOptions.length) {
              state.set(
                `selectr.${props.namespace}.focusedOption`,
                focusedOption + 1
              )
            } else {
              state.set(`selectr.${props.namespace}.focusedOption`, 0)
            }
          }
        ],
        false: [set(state`selectr.${props`namespace`}.focusedOption`, 0)]
      }
    ],
    false: []
  }
]
